import { QRCodeSVG } from "qrcode.react"

interface QRCodeProps {
  value: string
  label: string
  size?: number
}

/** Keeps a four-module quiet zone on a light surface so scanners work in either theme. */
export function QRCode({ value, label, size = 200 }: QRCodeProps) {
  return (
    <div className="coval-theme-light inline-flex max-w-full rounded-md bg-surface-default p-2 text-coval-text">
      <QRCodeSVG
        value={value}
        size={size}
        marginSize={4}
        bgColor="var(--surface-default)"
        fgColor="currentColor"
        role="img"
        aria-label={label}
        title={label}
        className="h-auto max-w-full"
      />
    </div>
  )
}
